import {
  Button,
  Grid,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useRemoveSusunanKeluarga } from "../../../../api/effects/mutations/SusunanKeluarga/removeSusunanKeluarga";
import useFetchAllSusunanKeluargaOT from "../../../../api/effects/queries/SusunanKeluarga/useFetchAllSusunanKeluargaOT";
import { RemoveModal } from "../../../../components/RemoveModal";
import { convertDate } from "../../../../utils/dateConvert";


const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  width: "90%",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "1%",
  [theme.breakpoints.down("sm")]: {
    padding: "10px",
  },
  margin: "1%",
}));
type Props = {
  onEdit: (id: number) => void;
};
export default function SusunanKeluargaOrangTuaTable({ onEdit }: Props) {
  const [deletingId, setDeletingId] = useState<number | null>(null);
  const [removeModalText, setRemoveModalText] = useState("");

  const { data: susunanKeluargaData } = useFetchAllSusunanKeluargaOT();

  const handleOpenRemoveModal = (text: string, id: number) => {
    setDeletingId(id);
    setRemoveModalText(`Remove ${text}?`);
  };

  const handleCloseRemoveModal = () => {
    setDeletingId(null);
  };



  const { mutateAsync: RemoveSusunanKeluarga } = useRemoveSusunanKeluarga({
    onSuccess() {
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });

  const handleRemove = () => {
    if (deletingId !== null) {
      RemoveSusunanKeluarga(deletingId);
      handleCloseRemoveModal();
    }
  };

  return (
    <Grid container justifyContent="center">
      <RemoveModal
        open={!!deletingId}
        handleClose={handleCloseRemoveModal}
        handleRemove={handleRemove}
        text={removeModalText}
      />
      <SquareGrid container>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Action</TableCell>
                <TableCell>Nama</TableCell>
                <TableCell>Hubungan Keluarga</TableCell>
                <TableCell>Tempat, Tanggal Lahir</TableCell>
                <TableCell>Pendidikan Terakhir</TableCell>
                <TableCell>Perusahaan Terakhir</TableCell>
                <TableCell align="center">Almarhum</TableCell>
                <TableCell align="center">Hapus</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {susunanKeluargaData?.map((row) => (
                <TableRow
                  key={row.SUSUNAN_KELUARGA_ID}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">
                    <Button
                      onClick={() => onEdit(row.SUSUNAN_KELUARGA_ID)}
                      disabled={!!deletingId}
                    >
                      Ubah
                    </Button>
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: row.IS_APPLICANT ? "bold" : "normal" }}
                  >
                    {row.NAMA}
                  </TableCell>
                  <TableCell>{row.HUBUNGAN_KELUARGA_ID}</TableCell>
                  <TableCell>
                    {row.TEMPAT_LAHIR} ,
                    {row.TANGGAL_LAHIR ? convertDate(row.TANGGAL_LAHIR) : "-"}
                  </TableCell>
                  <TableCell>{row.PENDIDIKAN_ID}</TableCell>
                  <TableCell>{row.PERUSAHAAN_TERAKHIR}</TableCell>
                  <TableCell align="center">
                    {row.ALMARHUM ? "Ya" : "Tidak"}
                  </TableCell>

                  <TableCell align="center">
                    <Button
                      color="error"
                      onClick={() =>
                        handleOpenRemoveModal(
                          `${row.NAMA}`,
                          row.SUSUNAN_KELUARGA_ID
                        )
                      }
                      disabled={!!deletingId}
                    >
                      Hapus
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Typography color="error">
          *Wajib Diisi dengan lengkap (Dari Orangtua, Saudara kandung, Termasuk
          Diri Saudara Sendiri)
        </Typography>
      </SquareGrid>
    </Grid>
  );
}